// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcp_a bhy_ke","ListItemIcon--empty":"bcp_b bhy_fl"};